var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 106,
    viewBox: "0 0 82 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.8748 81.3815L63.7948 52.4616L59.5991 48.266L34.8412 73.0241L22.3669 60.5497L18.2049 64.7116L34.8748 81.3815ZM9.58952 105.5C6.90473 105.5 4.66303 104.601 2.86442 102.802C1.06581 101.003 0.166504 98.7618 0.166504 96.077V9.92302C0.166504 7.23823 1.06581 4.99653 2.86442 3.19792C4.66303 1.39931 6.90473 0.5 9.58952 0.5H55.5832L81.8332 26.75V96.077C81.8332 98.7618 80.9339 101.003 79.1353 102.802C77.3366 104.601 75.0949 105.5 72.4102 105.5H9.58952ZM52.6665 29.6667V6.33333H9.58952C8.69216 6.33333 7.86952 6.70725 7.12159 7.45509C6.37375 8.20302 5.99984 9.02566 5.99984 9.92302V96.077C5.99984 96.9743 6.37375 97.797 7.12159 98.5449C7.86952 99.2927 8.69216 99.6667 9.58952 99.6667H72.4102C73.3075 99.6667 74.1302 99.2927 74.8781 98.5449C75.6259 97.797 75.9998 96.9743 75.9998 96.077V29.6667H52.6665Z",
    fill: "#FFB1B0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTask);
export default __webpack_public_path__ + "static/media/task.7592a9a92c0adc2d9ee40bbe7d0c192c.svg";
export { ForwardRef as ReactComponent };